import { SagaIterator } from "redux-saga";
import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";

import {
  fetchDataFailure,
  fetchDataSuccess,
  fetchProductLinesFailure,
  fetchProductLinesSuccess,
  fetchProductsFailure,
  fetchProductsSuccess,
  setCurrentProductLine,
} from "./actions";
import tenantService from "../../services/api/tenant";
import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCT_LINES_REQUEST,
  FETCH_REQUEST,
  UPDATE_CURRENT_PRODUCT_LINE,
} from "./constants";
import productLineAPIService from "../../services/api/productLine";
import productAPIService from "../../services/api/product";
import {
  selectAvailableProductLines,
  selectDefaultProductLine,
} from "./selectors";
import { IProductLine } from "../../services/api/productLine/types";
import { IUpdateCurrentProductLine } from "./types";

export function* fetchTenants(): SagaIterator {
  try {
    const data = yield call([tenantService, tenantService.getAll]);

    yield put(fetchDataSuccess(data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

export function* watchFetchTenants(): SagaIterator {
  yield takeLatest([FETCH_REQUEST], fetchTenants);
}

export function* watchGetProducts(): SagaIterator {
  yield takeLatest(FETCH_PRODUCTS_REQUEST, getProducts);
}

export function* watchGetProductLines(): SagaIterator {
  yield takeLatest(FETCH_PRODUCT_LINES_REQUEST, getProductLines);
}

export function* watchUpdateCurrentProductLine(): SagaIterator {
  yield takeLatest(UPDATE_CURRENT_PRODUCT_LINE, updateProductLine);
}

export function* updateProductLine({
  payload,
}: IUpdateCurrentProductLine): SagaIterator {
  const availableProductLines = yield select(selectAvailableProductLines);

  const productLine = availableProductLines.find((item: IProductLine) => {
    return item.code === payload;
  });

  if (productLine) {
    yield put(setCurrentProductLine(productLine));
  }
}

export function* getProducts(): SagaIterator {
  try {
    const data = yield call([productAPIService, productAPIService.getAll]);
    yield put(fetchProductsSuccess(data));
  } catch (error) {
    yield put(fetchProductsFailure(error));
  }
}

export function* getProductLines(): SagaIterator {
  try {
    const productLines = yield call([
      productLineAPIService,
      productLineAPIService.getAll,
    ]);
    yield put(fetchProductLinesSuccess(productLines));
    const defaultProductLIne = yield select(selectDefaultProductLine);
    if (defaultProductLIne) {
      yield put(setCurrentProductLine(defaultProductLIne));
    }
  } catch (error) {
    yield put(fetchProductLinesFailure(error));
  }
}

export function* metadataSaga(): SagaIterator {
  yield all([
    fork(watchFetchTenants),
    fork(watchGetProducts),
    fork(watchGetProductLines),
    fork(watchUpdateCurrentProductLine),
  ]);
}
